<div class="auth-page">
	@let currentUser = currentUser$ | async;

	<app-auth-info-cards> </app-auth-info-cards>

	@if (currentUser) {
		<div class="auth-form">
			<div class="image">
				<img
					ngSrc="/static/images/auth/logo-dark.svg"
					height="36"
					width="133"
				/>
			</div>

			<p>Your account is active, but we still need to verify your email address.</p>

			<p>Head over to {{ currentUser["email"] }} and copy the code, or click the link in the email.</p>

			<form [formGroup]="otpForm">
				<lib-input-otp formControlName="otp"></lib-input-otp>
			</form>

			<lib-button
				label="Verify"
				(onClick)="verify(currentUser['email'])"
			></lib-button>
			<lib-button
				label="Resend"
				(click)="resendVerificationCode(currentUser['email'])"
				[type]="ButtonType.Secondary"
			></lib-button>
		</div>
	}
</div>
